import { render, staticRenderFns } from "./SelectedLivingDonorOrganLinks.vue?vue&type=template&id=00e47c96&scoped=true"
import script from "./SelectedLivingDonorOrganLinks.vue?vue&type=script&lang=ts"
export * from "./SelectedLivingDonorOrganLinks.vue?vue&type=script&lang=ts"
import style0 from "./SelectedLivingDonorOrganLinks.vue?vue&type=style&index=0&id=00e47c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e47c96",
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/Organs.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2Fside-nav%2FSelectedLivingDonorOrganLinks.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/livingAllocations/side-nav/_locales/SelectedAllocationLinks.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2Fside-nav%2FSelectedLivingDonorOrganLinks.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports